/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RewardRedemptionSettings": {
                    "fields": {
                      "destinationType": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardRedemptionSettings.DestinationType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "manual": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardRedemptionSettings.ManualRedemptionPolicy",
                        "id": 2
                      },
                      "threshold": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardRedemptionSettings.ThresholdRedemptionPolicy",
                        "id": 3
                      },
                      "monthly": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardRedemptionSettings.MonthlyRedemptionPolicy",
                        "id": 4
                      }
                    },
                    "nested": {
                      "DestinationType": {
                        "values": {
                          "DT_DO_NOT_USE": 0,
                          "SAVINGS_ACCOUNT": 1
                        }
                      },
                      "ManualRedemptionPolicy": {
                        "fields": {}
                      },
                      "ThresholdRedemptionPolicy": {
                        "fields": {
                          "redemptionAccountToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "thresholdAmount": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "MonthlyRedemptionPolicy": {
                        "fields": {
                          "redemptionAccountToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "redemption_policy": {
                        "oneof": ["manual", "threshold", "monthly"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardRedemptionSettings && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardRedemptionSettings?.nested?.DestinationType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardRedemptionSettings?.nested?.ManualRedemptionPolicy && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardRedemptionSettings?.nested?.ThresholdRedemptionPolicy && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardRedemptionSettings?.nested?.MonthlyRedemptionPolicy) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Saved settings for rewards redemptions.
 * --
 *
 * SOURCE RewardRedemptionSettings @ squareup/corporate_card/resources/rewards/reward_redemption_settings.proto at 11:1
 */
export const RewardRedemptionSettings = $root.lookupType('squareup.corporate_card.resources.rewards.RewardRedemptionSettings');
fixType(RewardRedemptionSettings);
Builder.createAndAttachToType(RewardRedemptionSettings);
/**
 * SOURCE DestinationType @ squareup/corporate_card/resources/rewards/reward_redemption_settings.proto at 12:3
 */
RewardRedemptionSettings.DestinationType = $root.lookupEnum('squareup.corporate_card.resources.rewards.RewardRedemptionSettings.DestinationType').values;
/**
 * --
 * @desc Manual redemption policy.
 * --
 *
 * SOURCE ManualRedemptionPolicy @ squareup/corporate_card/resources/rewards/reward_redemption_settings.proto at 24:3
 */
RewardRedemptionSettings.ManualRedemptionPolicy = $root.lookupType('squareup.corporate_card.resources.rewards.RewardRedemptionSettings.ManualRedemptionPolicy');
fixType(RewardRedemptionSettings.ManualRedemptionPolicy);
Builder.createAndAttachToType(RewardRedemptionSettings.ManualRedemptionPolicy);
/**
 * --
 * @desc Threshold-based redemption policy.
 * --
 *
 * SOURCE ThresholdRedemptionPolicy @ squareup/corporate_card/resources/rewards/reward_redemption_settings.proto at 29:3
 */
RewardRedemptionSettings.ThresholdRedemptionPolicy = $root.lookupType('squareup.corporate_card.resources.rewards.RewardRedemptionSettings.ThresholdRedemptionPolicy');
fixType(RewardRedemptionSettings.ThresholdRedemptionPolicy, {
  redemptionAccountToken: {
    notEmpty: true
  },
  thresholdAmount: {
    required: true
  }
});
Builder.createAndAttachToType(RewardRedemptionSettings.ThresholdRedemptionPolicy);
/**
 * --
 * @desc Monthly redemption policy.
 * --
 *
 * SOURCE MonthlyRedemptionPolicy @ squareup/corporate_card/resources/rewards/reward_redemption_settings.proto at 44:3
 */
RewardRedemptionSettings.MonthlyRedemptionPolicy = $root.lookupType('squareup.corporate_card.resources.rewards.RewardRedemptionSettings.MonthlyRedemptionPolicy');
fixType(RewardRedemptionSettings.MonthlyRedemptionPolicy, {
  redemptionAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RewardRedemptionSettings.MonthlyRedemptionPolicy);